import { ref, computed, watch } from 'vue';
import parcelasService from '@/services/perfil/parcelas';
import { useSearchDebounce } from '@/composables/front/common/useSearchDebounce';

export function useParcelas() {
    let fetchGeneration = 0;

    const parcelas = ref([]);
    const loading = ref(false);
    const error = ref(null);
    const { search, debouncedSearch } = useSearchDebounce({ delay: 600, minChars: 1 });

    const meta = ref({ current_page: 1, last_page: 1, total: 0, per_page: 5 });

    const page    = computed(() => meta.value.current_page);
    const perPage = computed(() => meta.value.per_page);

    const fetchParcelas = async(newPage = page.value, newPerPage = perPage.value) => {
        const generation = ++fetchGeneration;
        loading.value = true;
        error.value = null;

        try {
            const result = await parcelasService.getParcelas({
                page: newPage,
                per_page: newPerPage,
                search: search.value,
            });

            if (generation !== fetchGeneration) return;

            parcelas.value = result.items;
            meta.value = result.meta;
        } catch (err) {
            if (generation !== fetchGeneration) return;

            error.value = err;
            parcelas.value = [];
            meta.value = { current_page: 1, last_page: 1, total: 0, per_page: newPerPage };

            if (process.env.NODE_ENV !== 'production') {
                console.error('Error al obtener parcelas:', err);
            }
        } finally {
            if (generation === fetchGeneration) {
                loading.value = false;
            }
        }
    };

    watch(debouncedSearch, () => {
        fetchParcelas(1, perPage.value);
    });

    return {
        parcelas,
        loading,
        error,
        search,
        meta,
        page,
        perPage,
        fetchParcelas,
    };
}
